// extracted by mini-css-extract-plugin
module.exports = {"filterMenu":"FilterMenu-filterMenu-3Tuqp Menu-menu-3XXIf"};